import React, { useContext, useEffect } from "react";
import { ThemeContext } from "styled-components";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Button } from "antd";
const Btn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) =>
    props.primary && props.disable !== true && "#35C974"};
  filter: ${(props) =>
    props.primary &&
    props.disable !== true &&
    `progid:DXImageTransform.Microsoft.gradient( startColorstr='#35C974', endColorstr='#503beb', GradientType=1 )`};
  background-color: ${(props) =>
    props.backgroundColor
      ? props.backgroundColor
      : props.disable === true
      ? props.theme.disable
      : props.primary
      ? props.theme.primary
      : props.secondary
      ? props.theme.secondary
      : props.backgroundColor
      ? props.backgroundColor
      : props.theme.white};
  direction: ${(props) =>
    props.lang === "fa" || props.lang === "ar" ? "rtl" : "ltr"};
  border-radius: ${(props) =>
    props.rounded ? "17.5px" : props.borderRdius || props.theme.buttonRadius};
  width: ${(props) => props.width || "110px"};
  height: ${(props) => props.height || "35px"};
  min-height: ${(props) => props.height || "35px"};
  color: ${(props) =>
    props.disable
      ? props.theme.disableText
      : props.default
      ? props.theme.primary
      : props.secondary
      ? props.theme.white
      : props.color
      ? props.color
      : "white"};
  font-size: ${(props) => props.theme.fontSizeMd};
  outline: none !important ;
  border: ${(props) =>
    props.disable
      ? "none"
      : props.default
      ? `1px solid ${props.theme.primary}`
      : "none"};
  font-family: inherit;
  box-shadow: none;
  cursor: pointer;
  &:hover {
    transition: all ease 350ms;
    background-color: ${(props) =>
      props.hoverBackgroundColor
        ? props.hoverBackgroundColor
        : props.disable
        ? props.theme.disable
        : props.notHoverable && props.default
        ? props.theme.white
        : props.secondary
        ? props.secondary
        : props.hoverbackgroundColor
        ? props.hoverbackgroundColor
        : props.theme.primary};
    color: ${(props) =>
      props.hoverColor
        ? props.hoverColor
        : props.disable
        ? props.theme.disableText
        : props.notHoverable && props.default
        ? props.theme.primary
        : props.theme.white};
  }
`;
const Loader = styled.div`
  display: flex;
  border: 4px solid white;
  margin: 0 auto;
  border-radius: 50%;
  position: absolute !important;
  align-self: center;
  border-top: 4px solid ${(props) => props.theme.secondary};
  width: ${(props) => props.height / 2 || "25px"};
  height: ${(props) => props.height / 2 || "25px"};
  -webkit-animation: spin 1s linear infinite; /* Safari */
  animation: spin 1s linear infinite;
  /* Safari */
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
const StyledButton = (props) => {
  const theme = useContext(ThemeContext);

  return (
    <Btn
      {...props}
      value={props.value}
      onClick={!props.disable || props.disable === false ? props.onClick : null}
      // loading={props.loading || true}
      // disabled={props.disabled || false}
      className={props.className}
      theme={theme}
      disable={props.disable}
    >
      {props.loading ? <Loader /> : props.children}
      {/* {props.loading && } */}
    </Btn>
  );
};

Button.propTypes = {};

export default StyledButton;
